import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAssignableRolesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAssignableRolesQuery = {
  __typename?: 'Query';
  getAssignableRoles: {
    __typename?: 'GetAssignableRolesResponse';
    items: Array<{
      __typename?: 'GetAssignableRolesResponseRoleData';
      name: string;
      uuid: string;
      scope?: string | null;
    }>;
  };
};

export const GetAssignableRolesDocument = gql`
  query GetAssignableRoles {
    getAssignableRoles {
      items {
        name
        uuid
        scope
      }
    }
  }
`;
export function useGetAssignableRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAssignableRolesQuery,
    GetAssignableRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAssignableRolesQuery,
    GetAssignableRolesQueryVariables
  >(GetAssignableRolesDocument, options);
}
export function useGetAssignableRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssignableRolesQuery,
    GetAssignableRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssignableRolesQuery,
    GetAssignableRolesQueryVariables
  >(GetAssignableRolesDocument, options);
}
export function useGetAssignableRolesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssignableRolesQuery,
        GetAssignableRolesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssignableRolesQuery,
    GetAssignableRolesQueryVariables
  >(GetAssignableRolesDocument, options);
}
export type GetAssignableRolesQueryHookResult = ReturnType<
  typeof useGetAssignableRolesQuery
>;
export type GetAssignableRolesLazyQueryHookResult = ReturnType<
  typeof useGetAssignableRolesLazyQuery
>;
export type GetAssignableRolesSuspenseQueryHookResult = ReturnType<
  typeof useGetAssignableRolesSuspenseQuery
>;
export type GetAssignableRolesQueryResult = Apollo.QueryResult<
  GetAssignableRolesQuery,
  GetAssignableRolesQueryVariables
>;
export function refetchGetAssignableRolesQuery(
  variables?: GetAssignableRolesQueryVariables,
) {
  return { query: GetAssignableRolesDocument, variables: variables };
}
